<div class="alert alert-danger" *ngIf="stripePaymentError">{{ stripePaymentError }}</div>
<div class="row">
	<div class="col">
		<app-signup-login *ngIf="checkoutSignupLogin" [existingUser]="!!user" [purchaserInfo]="info"></app-signup-login>
		<h3>Billing Info</h3>
		<div class="stripe-address">
			<div class="form-group">
				<label for="email" class="form-label">{{ formComponents.email.label }}</label>
				<input type="email" id="email" class="form-control" [value]="formComponents.email.value" (change)="setValue($event, 'email')">
			</div>
			<div id="stripe-address"></div>
		</div>
		<div [hidden]="stripePrimaryPaymentMethod && !showCardForm">
			<a *ngIf="(stripePaymentMethods.length || stripePrimaryPaymentMethod)" (click)="showCardForm = false" class="show-saved-cards">
				Use a saved card
			</a>
			<div id="stripe-card"></div>
			<div *ngIf="user">
				<input type="checkbox" id="save-card" [(ngModel)]="optedInToSaveCard">
				<label for="save-card">
					Save this credit card on my account to make checkout easier next time
				</label>
			</div>
			
		</div>
		
		<app-stripe-stored-cards *ngIf="(!showCardForm && user) && (stripePaymentMethods.length || stripePrimaryPaymentMethod)" 
			[user]="user"
			[customer]="stripeCustomer"
			[paymentMethods]="stripePaymentMethods"
			[primaryPaymentMethod]="stripePrimaryPaymentMethod"
			(selectedCard)="selectedStripeCard($event)"
			(useNewCard)="useNewCard()"
		></app-stripe-stored-cards>
	</div>
</div>

<br><br>
<div class="text-center">
	<button type="button" (click)="onSubmit($event)" class="button regular solid-green submit-purchase">
		{{inProgress ? 'Submitting Payment' : 'Complete Purchase'}}
	</button>
	<div class="credit-header">
		<br>
		<br>
		<p>— OR —</p>
		<br>
	</div>
	<div class="paypal-container">
		<app-paypal 
			*ngIf="!paypalDisabled else paypalDisabledMessage" 
			[cartPurchaseEnabled]="cartPurchaseEnabled" 
			[order]="order" 
			[promoCode]="promoCode"
			[amount]="amount" (paymentStatus)="handlePaymentStatus($event)"
			(paypalResult)="handlePayPalResult($event)">
		</app-paypal>
		<ng-template #paypalDisabledMessage>
			<div class="flex flex-column paypal-disabled">
				<div class="paypal-disabled-image" alt="PayPal Disabled"></div>
				<p>PayPal is disabled if you are buying a membership in addition to your promotions.</p>
			</div>
		</ng-template>
	</div>
</div>
<!-- <app-error-modal [modalId]="'payment-error-modal'" [title]="errorTitle" [text]="errorText" [soldOutExtra]="errorExtra"
	[soldOut]="soldOut" (soldOutEvent)="handleSoldOut($event)"></app-error-modal> -->

<app-new-error-modal modalId="payment-error-modal" [options]="errorOptions" [textList]="errorExtra"></app-new-error-modal>